import React from 'react';
import { EntityCategoryDatum, XAxisCategory } from 'src/components/BeaconV2Components/TopEntityChartV2/types';

/**
 * Used in the TopEntityChartV2 (Beacon Pro column chart) to create simple x axis labels that don't otherwise conform to the default behavior.
 * @param xAxisCategory
 * @returns a generic x axis label component for the top entity chart without links, click handlers, etc.
 */
export const GenericXAxisLabel = ({
  xAxisCategory,
  wrapperStyle
}: {
  xAxisCategory: XAxisCategory | EntityCategoryDatum;
  wrapperStyle?: React.CSSProperties;
}) => {
  return (
    <div
      style={{
        fontSize: '12px',
        textAlign: 'center',
        width: '90px',
        wordBreak: 'break-word',
        maxHeight: '70px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...wrapperStyle
      }}
    >
      <p style={{ marginBottom: 0 }} title={xAxisCategory.name}>
        {xAxisCategory.name}
      </p>
    </div>
  );
};
